<nav class="grid gap-2 sm:w-64 xl:w-80 grid-row-2 max-h-full">
  <article class="bg-[#121212] rounded-lg py-5 px-6" role="wrapper">
    <ul class="flex flex-col gap-5 ">
      <a class="flex gap-5 items-center" routerLink="/"
        routerLinkActive="active">
        <icon-home class="h-7 w-7 fill-zinc-400" /> <span class="hidden sm:block">{{dictionary?.header?.home}}</span></a>
      <a class="flex gap-5 items-center">
        <icon-search class="fill-zinc-400 h-7 w-7" /><span class="hidden sm:block">{{dictionary?.header?.search}}</span></a>
    </ul>
  </article>
  <article class="bg-[#121212] rounded-lg grid min-h-full" role="wrapper">
    <ul class="py-2 flex flex-col gap-5 ">
      <header>
        <div appContextualmenu [contextMenuParams]="{items:this._contextMenu.generateAddPlayListItems()}" class="flex sm:justify-between px-4 py-2 justify-center">
          <button [ariaLabel]="dictionary?.contain?.context_library" data-encore-id="buttonTertiary"
            class="flex items-center">
            <a class="flex gap-5">
              <icon-library /> <span class="hidden sm:block">{{dictionary?.contain?.library}}</span></a>
          </button>
          <button appContextualmenu [contextMenuParams]="{items:this._contextMenu.generateAddPlayListItems(),control:'left'}" [ariaLabel]="dictionary?.contain?.context_add" class="hidden sm:block bg-transparent transition-colors hover:bg-white/5 rounded-full h-8 w-8 p-2 hover:fill-white fill-zinc-400" data-encore-id="buttonTertiary">
            <icon-add class=" h-5 w-5" />
          </button>
        </div>
      </header>
    </ul>
    <section class="shadow-lg">
      <div appContextualmenu [contextMenuParams]="{items:this._contextMenu.generateAddPlayListItems()}" class="gap-2 px-3 my-3 hidden sm:flex">
        <button class="order" [id]="'playlist'" #playlist (click)="this.organize('playlist')"><span>{{dictionary?.contain?.filter?.list}}</span></button>
        <button class="order" [id]="'artist'" #artist (click)="this.organize('artist')"><span>{{dictionary?.contain?.filter?.artist}}</span></button>
        <button class="order" [id]="'album'" #album (click)="this.organize('album')"><span>{{dictionary?.contain?.filter?.albums}}</span></button>
      </div>
      <div appContextualmenu [contextMenuParams]="{items:this._contextMenu.generateAddPlayListItems()}" class="hidden sm:flex items-center justify-between pl-3 mr-6">
        <span (click)="InputSearch.focus(); tabIndex=0" class="flex items-center border-0 rounded-md"
          role="search">
          <input #inputElement (input)="this.search(inputElement)" (keydown.enter)="this.search(inputElement)"
            [ngClass]="['block bg-white/10 text-sm outline-none rounded-md py-[0.35rem]', tabIndex>-1?'opacity-1 w-[188px] pl-9':'opacity-0 w-6']"
            #InputSearch (blur)="tabIndex=-1" placeholder="{{dictionary?.contain?.context_search}}"
            [tabIndex]="tabIndex">
          <button [ariaLabel]="dictionary?.contain?.context_search" data-encore-id="buttonTertiary"
            [ngClass]="['bg-transparent transition-colors rounded-full h-9 w-9 fill-zinc-400',tabIndex==-1?'hover:bg-white/5 hover:fill-white':'cursor-text fill-zinc-300']">
            <icon-search class="absolute w-5 h-5 inset-0 m-auto" />
          </button>
        </span>
        <span class="flex min-w-0" role="filter">
          <button
            class="flex items-center min-w-0 hover:text-white hover:fill-white text-zinc-300 fill-zinc-400 transition-all">
            <span
              class="text-ellipsis overflow-hidden whitespace-nowrap text-inherit CircularStd-Light ms-3 text-[.95rem] hover:font-semibold">{{dictionary?.contain?.lasted}}</span>
            <icon-hamburguer-menu class="ms-1 fill-inherit" />
          </button>
        </span>
      </div>
      
    </section>
    <section data-encore-id="scroll" class="overflow-auto"><!--ARREGLAR-->
      @for (obj of this.dataWrapper$(); track obj.item.id) {
        @defer (on viewport) {
            <app-min-card [object]="obj" />
        }@loading {
            <skeleton-play-list-min-card />
        }@placeholder {
            <skeleton-play-list-min-card/>
        }@error {
            <div class="text-center text-white">Error</div>
        }
    }
    </section>
  </article>
</nav>